import TeamsBaseComponent, {ITeamsBaseComponentState} from "msteams-react-base-component";
import {Dropdown, IComboBoxOption} from "office-ui-fabric-react";
import React = require("react");
import {DefaultValues, MetadataFields} from "../../../models";
import {DarkModeCalloutStyles} from "../../DarkModeCalloutStyles";

export interface TeamsDocumentStatusTabLookupMetadataState extends ITeamsBaseComponentState {}

export interface TeamsDocumentStatusTabLookupMetadataProps {
    metadata: MetadataFields;
    isDarkMode: boolean;
    setSearchFilterCallback: (val: IComboBoxOption, field: string, id: string, defaultList: DefaultValues[]) => void;
}

export class TeamsDocumentStatusTabLookupMetadata extends TeamsBaseComponent<
    TeamsDocumentStatusTabLookupMetadataProps,
    TeamsDocumentStatusTabLookupMetadataState
> {
    constructor(props: TeamsDocumentStatusTabLookupMetadataProps) {
        super(props);
    }

    public render() {
        const hasOptions = this.props.metadata.DropDownOptions.length > 0;
        const isDisabled = this.props.metadata.Disabled || this.props.metadata.ManuallyDisabled;
        return (
            <div>
                <Dropdown
                    className={this.props.isDarkMode && isDisabled ? "darkModeLabelDisabled" : ""}
                    styles={this.props.isDarkMode ? DarkModeCalloutStyles.getDropdownStyle() : null}
                    placeholder={hasOptions ? "Select an option" : ""}
                    label={this.props.metadata.Field}
                    options={this.props.metadata.DropDownOptions}
                    disabled={isDisabled}
                    required={this.props.metadata.Required}
                    errorMessage={this.props.metadata.ErrorMessage}
                    onChange={(_, val) =>
                        this.props.setSearchFilterCallback(
                            val,
                            this.props.metadata.Field,
                            this.props.metadata.Id,
                            this.props.metadata.DefaultValuesList
                        )
                    }
                />
            </div>
        );
    }
}
